import React, { Component } from 'react';
import { Row, Col, Card, CardBody } from 'reactstrap';
import { Redirect, withRouter } from '../../utils/router-compat';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight } from '@fortawesome/free-solid-svg-icons';
import EditOfftakeEntryRightPan from '../../components/OfftakeEntry/EditOfftakeEntryRightPan';
import OfftakeEntryService from '../../services/OfftakeEntryService';
import AddOfftakeEntryLeftPan from '../../components/OfftakeEntry/AddOfftakeEntryLeftPan';
import CustomSpinner from '../../components/CustomSpinner/CustomSpinner';

class EditOfftakeEntry extends Component {
  constructor(props) {
    super(props);
    this.state = {
      offtakeEntry: {},
      uploadedFileData: {
        url: '',
        name: '',
        type: ''
      },
      uploadedFile: [],
      redirectToOfftakeVerificationStatus: false,
      isLoading: false
    }
  }


  componentDidMount() {
    const query = new URLSearchParams(this.props.location.search);
    const uuid = query.get('q');
    if (uuid) {
      this.getOfftakeEntryById(window.atob(uuid));
    }
  }


  // redirectOfftakeVerificationStatus = () => {
  //   let { redirectToOfftakeVerificationStatus } = this.state;
  //   redirectToOfftakeVerificationStatus = true;
  //   this.setState({ redirectToOfftakeVerificationStatus });
  // }

  getOfftakeEntryById = async (id) => {
    let { isLoading, offtakeEntry, uploadedFile, uploadedFileData } = this.state;
    try {
      isLoading = true;
      this.setState({ isLoading });
      const { data } = await OfftakeEntryService.getOfftakeEntryById({ id });
      isLoading = false;
      this.setState({ isLoading });
      if (data && data.data && data.data[0]) {
        offtakeEntry = data.data[0];
        /* uploadedFileData.url = offtakeEntry.invoice_url;
        const splitArr = offtakeEntry.invoice_url.split('/');
        uploadedFileData.name = splitArr[splitArr.length - 1];
        const splitArr1 = offtakeEntry.invoice_url.split('.');
        uploadedFileData.type = splitArr1[splitArr1.length - 1]; */

        uploadedFile = offtakeEntry.invoice_url;

        // let idCardBase64 = '';
        // this.getBase64(offtakeEntry.invoice_url, (result) => {
        //   idCardBase64 = result;
        // });

      }
      this.setState({ offtakeEntry, uploadedFile, uploadedFileData });
    } catch (error) {
      console.log(error);
    }
  }


  getBase64(file, cb) {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      cb(reader.result);
    };
    reader.onerror = (error) => {
      console.log('Error: ', error);
    };
  }

  redirectOfftakeVerificationStatus = () => {
    // let { redirectToVerificationStatus } = this.state;
    // redirectToVerificationStatus = true;
    const query = new URLSearchParams(this.props.location.search);
    // const uuid = query.get('q');
    const id = query.get('id');
    const name = query.get('name');
    // let { memberId, memberName, memberRole } = this.state;
    // let uuid = this.state.memberId;

    if (this.props.history) {
        if (id && name) {
          this.props.history.push(`/OfftakeEntriesVerificationStatus?id=${id}&name=${name}`);
        } else {
          this.props.history.push(`/OfftakeEntriesVerificationStatus`);
        }
    } else if (this.props.router && this.props.router.navigate) {
         if (id && name) {
          this.props.router.navigate(`/OfftakeEntriesVerificationStatus?id=${id}&name=${name}`);
        } else {
          this.props.router.navigate(`/OfftakeEntriesVerificationStatus`);
        }
    }

  }

  render() {
    const { isLoading, offtakeEntry, uploadedFile, uploadedFileData, redirectToOfftakeVerificationStatus } = this.state;

    return (
      <div>
        {isLoading && <CustomSpinner />}
        {redirectToOfftakeVerificationStatus && <Redirect to="/offtakeEntriesVerificationStatus" />}

        {
          offtakeEntry && offtakeEntry.invoice_number &&
          <>
            <Row>
              <Col>
                <div style={{ display: 'flex' }}>
                  <span onClick={this.redirectOfftakeVerificationStatus} className="select-vehicle-label" style={{ color: '#545cd8', cursor: 'pointer' }}>Offtake Entries Verification Status</span>
                  &nbsp;&nbsp;
                  <FontAwesomeIcon icon={faAngleRight} style={{ fontSize: '26px', cursor: 'pointer', marginTop: '-5px' }} color="#fdbb1f" />
                  &nbsp;&nbsp;
                  <span className="Offtake-Entry---Invo">Offtake Entry - Invoice#{offtakeEntry.invoice_number}</span>

                </div>
              </Col>
            </Row>

            <Row className="offtake-wrapper">
              <Col>
                <Card>
                  <CardBody>
                    <AddOfftakeEntryLeftPan uploadedFile={uploadedFile} uploadedFileData={uploadedFileData} from="editOfftakeEntry" />
                  </CardBody>
                </Card>
              </Col>
              <Col>
                <Card>
                  <CardBody>
                    <EditOfftakeEntryRightPan offtakeEntry={offtakeEntry} />
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </>
        }
      </div>
    );
  }
}


export default withRouter(EditOfftakeEntry);